import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_bridge_print} from "../../../../function/FnPosBridge";
import { jinjuNubigoMobileOrderFg, ygyMobileOrderFg, baeminMobileOrderFg, apiMobileOrderFg } from "utils/Utils"
import { MobileOrderFg } from "types";

@observer
class RePrintView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            print_check_type : "0",
            print_check_type_api: "5"
        }
    }

    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        const fn_chage_type = (type) => {
            this.setState({print_check_type:type});
        }
        const fn_chage_type_api = (type) => {
            this.setState({print_check_type_api:type});
        }

        const isApiPrint = ((rootStore.viewStore.getOrderDetail.mobileOrderFg != "20" 
            && apiMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)) 
            || baeminMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)
            || rootStore.viewStore.getOrderDetail.mobileOrderFg === MobileOrderFg.NAVER_BOOKING
            || rootStore.viewStore.getOrderDetail.mobileOrderFg === MobileOrderFg.NAVERCONNECT
            || rootStore.viewStore.getOrderDetail.mobileOrderFg === MobileOrderFg.HASAMDONG_COFFEE
            || rootStore.viewStore.getOrderDetail.mobileOrderFg === MobileOrderFg.DDANGYO
            || rootStore.viewStore.getOrderDetail.mobileOrderFg === MobileOrderFg.DDANGBAEDAL);
            
        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerReprintView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>재출력 선택</h1>
                        </div>
                        <div className="section_print">
                            <ul className="list_print">
                                {
                                    isApiPrint ?
                                    <>
                                    <li><label
                                        onClick={event => {event.preventDefault(); fn_chage_type_api("5")}}
                                    ><input type="radio" name="print" checked={this.state.print_check_type_api==="" || this.state.print_check_type_api==="5"}
                                        onChange={event => fn_chage_type_api("5")}
                                    /><span>영수프린터 + 주방프린터</span></label></li>
                                    <li
                                        onClick={event => {event.preventDefault(); fn_chage_type_api("7")}}
                                    ><label><input type="radio" name="print" checked={this.state.print_check_type_api==="7"}
                                                onChange={event => fn_chage_type_api("7")}
                                    /><span>영수프린터</span></label></li>
                                    <li
                                        onClick={event => {event.preventDefault(); fn_chage_type_api("8")}}
                                    ><label><input type="radio" name="print" checked={this.state.print_check_type_api==="8"}
                                                onChange={event => fn_chage_type_api("8")}
                                    /><span>주방프린터</span></label></li>
                                    </>
                                    :
                                    <>
                                    <li><label
                                        onClick={event => {event.preventDefault(); fn_chage_type("0")}}
                                    ><input type="radio" name="print" checked={this.state.print_check_type==="" || this.state.print_check_type==="0"}
                                        onChange={event => fn_chage_type("0")}
                                    /><span>POS 고객전표 + POS 주방주문서</span></label></li>
                                    <li
                                        onClick={event => {event.preventDefault(); fn_chage_type("2")}}
                                    ><label><input type="radio" name="print" checked={this.state.print_check_type==="2"}
                                                onChange={event => fn_chage_type("2")}
                                    /><span>POS 고객전표</span></label></li>
                                    <li
                                        onClick={event => {event.preventDefault(); fn_chage_type("1")}}
                                    ><label><input type="radio" name="print" checked={this.state.print_check_type==="1"}
                                                onChange={event => fn_chage_type("1")}
                                    /><span>POS 주방주문서</span></label></li>
                                    </>
                                }
                            </ul>
                            <div className="wrap_full_btn">
                                {
                                    isApiPrint
                                    ?
                                    <button
                                        onClick={event => {
                                            fn_bridge_print(rootStore,this.state.print_check_type_api);
                                            fn_chage_type_api("5");
                                        } }
                                    >출력</button>
                                    :
                                    <button
                                        onClick={event => {
                                            fn_bridge_print(rootStore,this.state.print_check_type);
                                            fn_chage_type("0");
                                        } }
                                    >출력</button>
                                }
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {
                                    isApiPrint ? fn_chage_type_api("5") : fn_chage_type("0");
                                    layerStore.setLayerReprint(false);
                                } }
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RePrintView;